import React, { memo } from 'react';

import { defaultSize, sizePropsTypes } from './icons.constants';

const SpeakerOffIcon = ({ size = defaultSize, ...props }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 24 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M4.34 2.93L2.93 4.34L7.29 8.7L7 9L3 9L3 15L7 15L12 20L12 13.41L16.18 17.59C15.53 18.08 14.8 18.47 14 18.7L14 20.76C15.34 20.46 16.57 19.84 17.61 19.01L19.66 21.06L21.07 19.65L4.34 2.93ZM10 15.17L7.83 13L5 13L5 11L7.83 11L8.71 10.12L10 11.41L10 15.17ZM19 12C19 12.82 18.85 13.61 18.59 14.34L20.12 15.87C20.68 14.7 21 13.39 21 12C21 7.72 18.01 4.14 14 3.23L14 5.29C16.89 6.15 19 8.83 19 12ZM12 4L10.12 5.88L12 7.76ZM16.5 12C16.5 10.23 15.48 8.71 14 7.97L14 9.76L16.48 12.24C16.49 12.16 16.5 12.08 16.5 12Z"
      fill="currentColor"
    />
  </svg>
);

SpeakerOffIcon.propTypes = {
  ...sizePropsTypes,
};

export default memo(SpeakerOffIcon);
